import { FatalEffectHookError } from '../errors'
import { EventTarget } from '../models/EventTarget'

import type { TypedEvent } from '../models/TypedEvent'
import type {
  EventEffectHook,
  EventListener,
  TypedEventConstructor
} from '../types'

/**
 * 创建继承于 TypedEvent 事件子类的 Event Effect Hook
 * @param EventClass 事件类
 * @returns
 */
export function createEffectHook<
  Class extends TypedEventConstructor,
  Event extends TypedEvent = InstanceType<Class>
>(EventClass: Class): EventEffectHook<Class, Event> {
  const event = new EventClass()
  return {
    [`${event.type}Capture`]: (listener?: EventListener) => {
      if (!listener) return
      if (!EventTarget.__r_current_event_target) throw new FatalEffectHookError()
      const target = EventTarget.__r_current_event_target
      target.addEventListener(event.type, listener, {
        capture: true
      })
    },
    [event.type]: (listener?: EventListener) => {
      if (!listener) return
      if (!EventTarget.__r_current_event_target) throw new FatalEffectHookError()
      const target = EventTarget.__r_current_event_target
      target.addEventListener(event.type, listener)
    }
  } as EventEffectHook<Class, Event>
}
